/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWaveSawTool = createReactComponent("wave-saw-tool", "IconWaveSawTool", [
  ["path", { d: "M3 12h5l4 8v-16l4 8h5", key: "svg-0" }]
]);

export { IconWaveSawTool as default };
//# sourceMappingURL=IconWaveSawTool.js.map
